(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9314],{

/***/ 75251:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/p/[profilePath]",
      function () {
        return __webpack_require__(23676);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 23676:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _profilePath_; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/components/I18n/index.ts + 3 modules
var I18n = __webpack_require__(34769);
// EXTERNAL MODULE: ./src/components/Authentication/index.ts + 2 modules
var Authentication = __webpack_require__(6990);
// EXTERNAL MODULE: ./src/components/index.ts + 34 modules
var components = __webpack_require__(638);
// EXTERNAL MODULE: ./src/components/Core/index.ts + 44 modules
var Core = __webpack_require__(44145);
// EXTERNAL MODULE: ./src/components/Pages/Profile/ProfilePersoPage.module.scss
var ProfilePersoPage_module = __webpack_require__(50583);
var ProfilePersoPage_module_default = /*#__PURE__*/__webpack_require__.n(ProfilePersoPage_module);
// EXTERNAL MODULE: ./src/hooks/use-translate.ts
var use_translate = __webpack_require__(35511);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/components/Pages/Profile/ProfilePersoPageNotFound.tsx






var ProfilePersoPageNotFound = function(props) {
    var ref = (0,use_translate/* useTranslate */.q)(), t = ref.t, locale = ref.locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: "hero is-fullheight-with-navbar is-unselectable",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "hero-body",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container is-fluid has-text-centered",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "has-text-black is-size-4 has-text-weight-light",
                            children: [
                                t(props.errorMsgKey),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "icon is-large",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fas fa-3x fa-times"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (ProfilePersoPage_module_default()).goGalleryButtonContainer,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Core/* OwardLinkButton */.HD, {
                                    name: t("page.profile.return_gallery")
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
};

// EXTERNAL MODULE: ../common-utils/dist/index.js
var dist = __webpack_require__(95196);
// EXTERNAL MODULE: ./src/utils/index.ts + 1 modules
var utils = __webpack_require__(93629);
;// CONCATENATED MODULE: ./src/pages/[lang]/p/[profilePath].tsx











var Page = function(props) {
    var ref, ref1, ref2;
    var locale = (0,use_translate/* useTranslate */.q)().locale;
    var ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* PageWrapper */.FEV, {
        pageTitle: !props.errorMsgKey && "".concat((ref = props.profile) === null || ref === void 0 ? void 0 : ref.name, " (").concat((0,dist.findTranslationOrDefault)((ref1 = props.profile) === null || ref1 === void 0 ? void 0 : ref1.job, locale), ") | ").concat((0,dist.findTranslationOrDefault)(props.profile.location.city, locale)),
        pageDescription: !props.errorMsgKey && (0,utils/* ProfileDescription */.lA)(props.profile),
        pageImage: !props.errorMsgKey && ((ref3 = (ref2 = props.profile) === null || ref2 === void 0 ? void 0 : ref2.avatarUrl) !== null && ref3 !== void 0 ? ref3 : undefined),
        noIndex: !!props.errorMsgKey,
        children: props.errorMsgKey ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfilePersoPageNotFound, {
            errorMsgKey: props.errorMsgKey
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ProfilePersoPage */.zg1, {
            profile: props.profile
        })
    });
};
var CompletePage = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(I18n/* WithLocale */._t, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Authentication/* WithAuthentication */.K, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Page, (0,_object_spread/* default */.Z)({}, props))
        }))
    }));
};
var __N_SSP = true;
/* harmony default export */ var _profilePath_ = (CompletePage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(24458), __webpack_exec__(75251); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);